import styled from 'styled-components'
import { LinkComponent, themeColor, themeFontFamily } from 'LibNeo'

export const ErrorContainer = styled.div`
	justify-content: center;
	align-items: center;
`

export const Container = styled.div`
	display: flex;
	width: 100%;
	justify-content: space-evenly;
`

export const Support = styled(LinkComponent)`
	margin-right: 24px;
	text-decoration-style: dashed;
`

export const Ups = styled.div`
	display: flex;
	align-items: end;
	font-size: 24px;
	height: 72px;
	font-weight: 600;
	color: ${themeColor('gray', 8)};
	font-family: ${themeFontFamily('SBSansText')};
	padding: 0 0 4px;
`

export const ErrorCodeText = styled.span`
	line-height: 16px;
	font-size: 12px;
	color: ${themeColor('extraBackground3')};
	font-family: ${themeFontFamily('SBSansText')};
`

export const ErrorCode = styled.p`
	margin: 0 0 16px;
	padding: 0;
	line-height: 32px;
`

export const TextContainer = styled.div`
	margin-bottom: 79px;

	h2 {
		margin: 0;
		line-height: 72px;
	}

	p {
		line-height: 32px;
	}
`

export const InfoContainer = styled.div`
	max-width: 480px;
`

export const ErrorTitle = styled.div`
	margin: 0 0 14px;
	padding: 1px 0 0;
	line-height: 41px;
	font-weight: 600;
	font-size: 32px;
	color: ${themeColor('gray', 6)};
	font-family: ${themeFontFamily('SBSansText')};
`

export const AdviceContainer = styled.div`
	margin-bottom: 50px;
`

export const AdviceTextContainer = styled.p`
	margin: 0 0 16px;
	padding: 0;
	font-size: 16px;
	line-height: 28px;
`

export const AdviceText = styled.span`
	color: ${themeColor('extraBackground3')};
	font-family: ${themeFontFamily('SBSansText')};
`
